// Ported from `app/drill/page.tsx` in `git@git.fugl.dev:sks/yominoki.git` @
// `515ce239`.
//
// The server component awaited `getDrillCandidates("ja_to_en")` and passed the
// result to `<DrillSession initialCandidates={...}>`. The prop name survives
// but its meaning shifts: it is now the resolved value of a fetch, and until
// it resolves there is nothing to hand over — so the page renders the same
// "Loading..." the session already shows between rounds rather than mounting
// DrillSession with an empty array, which would flash an empty picker.
//
// `import "./drill.css"` is gone with the route-local stylesheet; those rules
// live in ../index.css now.

import { Navigate } from "react-router";
import { DrillSession } from "../components/drill/drill-session";
import { useResource } from "../hooks/use-resource";
import { useSession } from "../hooks/use-session";
import { getDrillCandidates } from "../lib/api";

export function DrillPage() {
  const session = useSession();
  const signedIn = session.status === "signed-in";
  const { resource } = useResource(
    (signal) =>
      signedIn ? getDrillCandidates("ja_to_en", signal) : Promise.resolve([]),
    [signedIn],
  );

  if (session.status === "unknown") return <Shell>Loading…</Shell>;
  if (session.status === "signed-out") return <Navigate to="/" replace />;

  if (resource.status === "loading") return <Shell>Loading…</Shell>;
  if (resource.status === "error") {
    return <Shell>Could not load a drill. Reload to try again.</Shell>;
  }

  return (
    <main className="bg-paper text-ink flex min-h-svh flex-col">
      <DrillSession initialCandidates={resource.data} />
    </main>
  );
}

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <main className="bg-paper text-ink flex min-h-svh flex-col items-center justify-center">
      <p className="text-muted-foreground animate-pulse text-sm">{children}</p>
    </main>
  );
}
